<template>
  <div class="explorerMain">
    <div class="explorerContent">

      <div class="tableMain" v-if="page == 'form' && (mainData['forms']['length'] > 0)"
          @scroll="tableScroll($event)">
        <div :class="['tableRow', 'tableContent', ((tableData['fileSel'] == f['file']) ? 'selected' : '')]" v-for="(f, i) in mainData['forms']" :key="'form' + i"
            @mousedown="tableMouseDown($event, f['file'])"
            @dblclick="tableDblClick($event, 'form', f['file'])">
          <div class="tableFileDetails"> 
            <div class="tableFileName"> {{(f['file'].split('\.')['length'] > 0) ? (f['file'].split('\.')[0]) : f['file']}} </div>
            <div class="tableFileLastEdit"> Last Edited: {{f['lastedit']}} </div>
          </div>
          <div class="tableFileExtension" :style="{ 'background-color': tableData['extColors'][f['extension'].replace('\.', '')] }">
            {{f['extension'].replace('\.', '')}}
          </div>
        </div>
      </div>

      <div class="tableMain" v-else-if="page == 'image' && (mainData['images']['length'] > 0)"
          @scroll="tableScroll($event)">
        <div :class="['tableRow', 'tableContent', ((tableData['fileSel'] == f['file']) ? 'selected' : '')]" v-for="(f, i) in mainData['images']" :key="'image' + i"
            @mousedown="tableMouseDown($event, f['file'])"
            @dblclick="tableDblClick($event, 'image', f['file'])">
          <div class="tableFileDetails"> 
            <div class="tableFileName"> {{(f['file'].split('\.')['length'] > 0) ? (f['file'].split('\.')[0]) : f['file']}} </div>
            <div class="tableFileLastEdit"> Last Edited: {{f['lastedit']}} </div>
          </div>
          <div class="tableFileExtension" :style="{ 'background-color': tableData['extColors'][f['extension'].replace('\.', '')] }">
            {{f['extension'].replace('\.', '')}}
          </div>
        </div>
      </div>

      <div class="tableMain" v-else-if="page == 'key' && (mainData['keys']['length'] > 0)"
          @scroll="tableScroll($event)">
        <div :class="['tableRow', 'tableContent', ((tableData['fileSel'] == f['file']) ? 'selected' : '')]" v-for="(f, i) in mainData['keys']" :key="'keyObj' + i"
            @mousedown="tableMouseDown($event, f['file'])"
            @dblclick="tableDblClick($event, 'key', f['file'])">
          <div class="tableFileDetails"> 
            <div class="tableFileName"> {{(f['file'].split('\.')['length'] > 0) ? (f['file'].split('\.')[0]) : f['file']}} </div>
            <div class="tableFileLastEdit"> Last Edited: {{f['lastedit']}} </div>
          </div>
          <div class="tableFileExtension" :style="{ 'background-color': tableData['extColors'][f['extension'].replace('\.', '')] }">
            {{f['extension'].replace('\.', '')}}
          </div>
        </div>
      </div>

      
      <div class="tableMain" v-else-if="page == 'keyEdit' && (Object.keys(mainData['keyObj'])['length'] > 0)">
        <div :class="['tableRow', 'tableContent', ((tableData['fileSel'] == f) ? 'selected' : '')]" v-for="(f, i) in Object.keys(mainData['keyObj'])" :key="'key' + i"
            @mousedown="tableMouseDown($event, f)"
            @dblclick="tableDblClick($event, 'keyedit', f)">
          <div class="tableFileDetails"> 
            <div class="tableFileName"> {{f}} </div>
            <div class="tableFileLastEdit"></div>
          </div>
          <div class="tableFileExtension" :style="{ 'background-color': tableData['extColors'][Array.isArray(mainData['keyObj'][f]) ? 'array' : typeof mainData['keyObj'][f]] }">
            {{Array.isArray(mainData['keyObj'][f]) ? 'array' : typeof mainData['keyObj'][f]}}
          </div>
        </div>
      </div>
      
      <div class="tableMain" v-else-if="page == 'arrayEdit' && (Object.keys(mainData['keyObj'][mainData['arraySel']][0])['length'] > 0)">
        <div :class="['tableRow', 'tableContent', ((tableData['fileSel'] == f) ? 'selected' : '')]" v-for="(f, i) in Object.keys(mainData['keyObj'][mainData['arraySel']][0])" :key="'array' + i"
            @mousedown="tableMouseDown($event, f)">
          <div class="tableFileDetails"> 
            <div class="tableFileName"> {{f}} </div>
            <div class="tableFileLastEdit"></div>
          </div>
          <div class="tableFileExtension" :style="{ 'background-color': tableData['extColors'][Array.isArray(mainData['keyObj'][mainData['arraySel']][0][f]) ? 'array' : typeof mainData['keyObj'][mainData['arraySel']][0][f]] }">
            {{Array.isArray(mainData['keyObj'][mainData['arraySel']][0][f]) ? 'array' : typeof mainData['keyObj'][mainData['arraySel']][0][f]}}
          </div>
        </div>
      </div>

      <div class="tableNone" v-else-if="page">{{tableData['tableMsg']}}</div>
      <div class="tableNone" v-else>No Mode Selected</div>

      <div class="explorerFunctions" ref="explorerFunctions">
        <div class="explorerTitle">{{mainData['arraySel'] ? mainData['arraySel'] : (mainData['keySel'] ? mainData['keySel'] : '')}}</div>

        <button class="explorerButton" @click="tableBtn('openform')" v-if="page == 'form'"> Open </button>
        <button class="explorerButton" @click="tableBtn('deleteform')" v-if="page == 'form'"> Delete </button>

        <button class="explorerButton" @click="tableBtn('addimage')" v-if="page == 'image'"> Add </button>
        <button class="explorerButton" @click="tableBtn('deleteimage')" v-if="page == 'image'"> Delete </button>

        <button class="explorerButton" @click="tableBtn('newkeyedit')" v-if="page == 'key'"> New </button>
        <button class="explorerButton" @click="tableBtn('addjson')" v-if="page == 'key'"> Add </button>
        <button class="explorerButton" @click="tableBtn('deletejson')" v-if="page == 'key'"> Delete </button>

        <button class="explorerButton" @click="tableBtn('newkeyedit')" v-if="page == 'keyEdit'"> New </button>
        <button class="explorerButton" @click="tableBtn('deletekeyedit')" v-if="page == 'keyEdit'"> Delete </button>
        <button class="explorerButton" @click="tableBtn('backkeyedit')" v-if="page == 'keyEdit'"> Back </button>
        
        <button class="explorerButton" @click="tableBtn('newkeyedit')" v-if="page == 'arrayEdit'"> New </button>
        <button class="explorerButton" @click="tableBtn('deletearray')" v-if="page == 'arrayEdit'"> Delete </button>
        <button class="explorerButton" @click="tableBtn('backarray')" v-if="page == 'arrayEdit'"> Back </button>

        <button class="explorerButton" @click="tableBtn('close')"> Close </button>
      </div>

      <div class="newKeyMain" v-if="mainData['newKeyShow']">
        <div class="newKeyBody">
          <div class="newKeyTitle">Key Name</div>
          <input type="text" v-model="mainData['newKey']"/>
          <div class="newKeyFunctions">
            <button @click="tableBtn('newjsonadd', '')" v-if="page == 'key'">Create</button>

            <button @click="tableBtn('newkeyadd', 'string')" v-if="page == 'keyEdit'">String</button>
            <button @click="tableBtn('newkeyadd', 'array')" :style="{'margin': '0 0 0 5px'}" v-if="page == 'keyEdit'">Array</button>

            <button @click="tableBtn('newarrayadd', 'string')" v-if="page == 'arrayEdit'">String</button>
          </div>
          <div class="newKeyLowerFunctions">
            <button @click="tableBtn('newkeyedit')">Close</button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  
  
  export default {
    name: 'reportExplorer',
    components: {
      
    },
    props: {
      page: { type: String, default: "" },
      show: { type: Boolean, default: false },
    },
    data() { 
      return {
        mainData: {
          'forms': [],
          'images': [],
          'keys': [],

          'keySel': '',
          'keyObj': {},
          'newKey': '',
          'newKeyShow': false,

          'arraySel': '',
        },

        tableData: {
          'tableMsg': 'Loading',
          'fileSel': '',

          'extColors': {
            'json': '#d36cf5',
            'jpg': '#60b3f7',
            'png': '#a159ff',
            'string': '#e6bf40',
            'array': '#3c7a20',
            'object': '#d94e38',
          },
        },
        fileData: {
          'fileTypes': [
            'image/jpeg',
            'image/png',
          ]
        },
      }
    },
    mounted() {
      this.loadData()
    },
    beforeDestroy() {
      
    },
    methods: {
      loadData: async function() {
        //---- Get Data based on page
        switch(this.page) {
          case 'form':
            this.loadForms();
            break;
          case 'image':
            this.loadImages();
            break;
          case 'key':
            this.loadKeys();
            break;
          case 'arrayEdit':
          case 'keyEdit':
            if ((Object.keys(this.mainData['keyObj'])['length'] <= 0) || !this.mainData['arraySel']) {
              this.$emit('update:page', 'key');
              this.loadKeys();
            }
            break;
        }
      },
      loadForms: async function() {
        try {
          this.$set(this.tableData, 'tableMsg', 'Loading Forms');
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform', null);
          // console.log('%cRequest Success', 'color: #00ff00;', request);
          if (Array.isArray(request) && (request['length'] > 0)) { 
            this.$set(this.mainData, 'forms', []);
            request.forEach((f) => { this.mainData['forms'].push(f); });
          } else {
            this.$set(this.tableData, 'tableMsg', 'No Forms Found');
          }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); };
      },
      loadImages: async function() {
        try {
          this.$set(this.tableData, 'tableMsg', 'Loading Images');
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTimage', null);
          console.log('%cRequest Success', 'color: #00ff00;', request);
          if (Array.isArray(request) && (request['length'] > 0)) { 
            this.$set(this.mainData, 'images', []);
            request.forEach((img) => { this.mainData['images'].push(img); });
          } else {
            this.$set(this.tableData, 'tableMsg', 'No Images Found');
          }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); };
      },
      loadKeys: async function() {
        try {
          this.$set(this.tableData, 'tableMsg', 'Loading Keys');
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ReportKeys', null);
          // console.log('%cRequest Success', 'color: #00ff00;', request);
          if (Array.isArray(request) && (request['length'] > 0)) { 
            this.$set(this.mainData, 'keys', []);
            request.forEach((key) => { this.mainData['keys'].push(key); });
          } else {
            this.$set(this.tableData, 'tableMsg', 'No Keys Found');
          }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); };
      },

      //---- Table Methods
      tableMouseDown: async function(e, file) {
        this.$set(this.tableData, 'fileSel', file);
      },
      tableDblClick: async function(e, btn, file) {
        switch(btn) {
          case 'form':
            this.$emit('formSelect', file);
            this.tableBtn('close');
            break;
          case 'key':
            var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ReportKeys&fileName=' + file, null);
            // console.log(request);
            if (typeof request['data'] == 'object') {
              this.$set(this.mainData, 'keyObj', request['data']);
              
              //-- Set selected key, for saving
              this.$set(this.mainData, 'keySel', file);

              //-- Set page to edit mode
              this.$emit('update:page', 'keyEdit');
            }
            break;
          case 'keyedit':
            switch (Array.isArray(this.mainData['keyObj'][file]) ? 'array' : typeof this.mainData['keyObj'][file]) {
              case 'array':
                this.$set(this.mainData, 'arraySel', file);
                if (this.mainData['keyObj'][file]['length'] <= 0) {
                  this.mainData['keyObj'][file].push({});
                }

                this.$nextTick(() => {
                  //-- Set page to edit mode
                  this.$emit('update:page', 'arrayEdit');
                });
                break;
            }
            break;
        }
      },
      tableScroll: async function(e) {

      },
      tableReset: async function() {
        this.$set(this.tableData, 'fileSel', '');
      },

      tableBtn: async function(cmd, data) {
        switch(cmd) {
          case 'openform':
            this.$emit('formSelect', this.tableData['fileSel']);
            this.tableReset();
            this.tableBtn('close');
            break;
          case 'deleteform':
            if (this.tableData['fileSel']) {
              var request = await this.$apiCallV2('/ReportDesigner/DeleteFile?folderPath=ROTform&fileName=' + this.tableData['fileSel'], null);
              console.log(request);

              //---- Refresh Explorer
              this.loadForms();
            } else { console.log('Empty Selection'); }
            break;

          case 'addimage':
            //---- Set variables
            var funcBarDOM = this.$refs['explorerFunctions'];

            //---- Get File
            var inputDOM = document.createElement('input');
            inputDOM['type'] = 'file';
            inputDOM['multiple'] = true;

            inputDOM.addEventListener('change', (e) => { 
              if (inputDOM['files']['length'] > 0) {
                Array.from(inputDOM['files']).forEach((f) => {
                  if ((this.fileData['fileTypes'].filter((t) => { return t == f['type']; })['length'] > 0)) { 
                    //---- File Reader
                    var reader  = new FileReader();
                    reader.onloadend = () => { this.fileUploadImage(f ,reader['result']); }
                    reader.readAsDataURL(f);
                  }
                });
              }
            });

            this.$nextTick(() => { inputDOM.click(); });

            break;
          case 'deleteimage':
            if (this.tableData['fileSel']) {
              var request = await this.$apiCallV2('/ReportDesigner/DeleteFile?folderPath=ROTimage&fileName=' + this.tableData['fileSel'], null);
              console.log(request);

              //---- Refresh Explorer
              this.loadImages();
            } else { console.log('Empty Selection'); }
            break;
          
          case 'newjson':
            break;
          case 'addjson':
            console.log('Add Json');
            //---- Get File
            var inputDOM = document.createElement('input');
            inputDOM['type'] = 'file';
            inputDOM['multiple'] = true;

            inputDOM.addEventListener('change', (e) => { 
              if (inputDOM['files']['length'] > 0) {
                Array.from(inputDOM['files']).forEach((f) => {
                  if (f['type'] == 'application/json') { 
                    //---- File Reader
                    var reader  = new FileReader();
                    reader.onloadend = () => { this.fileUploadJSON(f ,reader['result']); }
                    reader.readAsText(f);
                  }
                });
              }
            });
            
            this.$nextTick(() => { inputDOM.click(); });
            break;
          case 'deletejson':
            if (this.tableData['fileSel']) {
              var request = await this.$apiCallV2('/ReportDesigner/DeleteFile?folderPath=ReportKeys&fileName=' + this.tableData['fileSel'], null);
              
              //-- Reload the keys
              this.loadKeys();
            }
            break;
          case 'newjsonadd':
            if (this.mainData['newKey'].trim()) {
              //-- Save the edit
              var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=key&folderPath=ReportKeys&fileName=' + this.mainData['newKey'], { 'JSON': {} });

              //-- Close new key editor
              this.$set(this.mainData, 'newKeyShow', false);

              //-- Clear data
              this.$set(this.mainData, 'newKey', '');

              //-- Reload the keys
              this.loadKeys();
            }
            break;

          case 'newkeyedit':
            //-- Clear data
            this.$set(this.mainData, 'newKey', '');

            this.$set(this.mainData, 'newKeyShow', !this.mainData['newKeyShow']);
            break;
          case 'deletekeyedit':
            //-- Delete the key
            delete this.mainData['keyObj'][this.tableData['fileSel']];
            this.$set(this.tableData, 'fileSel', '');
            
            //-- Save the edit
            var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=key&folderPath=ReportKeys&fileName=' + this.mainData['keySel'], null);
            break;
          case 'backkeyedit':
            //-- Reset keys
            this.$set(this.mainData, 'keyObj', {});
            this.$set(this.mainData, 'keySel', '');

            //-- Go back to show Json files
            this.$emit('update:page', 'key');
            break;
          case 'newkeyadd':
            switch(data) {
              case 'string':
                this.$set(this.mainData['keyObj'], this.mainData['newKey'], '');
                break;
              case 'array':
                this.$set(this.mainData['keyObj'], this.mainData['newKey'], []);
                break;
              case 'object':
                break;
            }

            if (this.mainData['newKey'].trim()) {
              //-- Save the edit
              var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=key&folderPath=ReportKeys&fileName=' + this.mainData['keySel'], { 'JSON': this.mainData['keyObj'] });

              //-- Close new key editor
              this.$set(this.mainData, 'newKeyShow', false);

              //-- Clear data
              this.$set(this.mainData, 'newKey', '');
            }
            break;
          
          case 'deletearray':
            break;
          case 'backarray':
            //-- Reset keys
            this.$set(this.mainData, 'arraySel', '');

            //-- Go back to show Json files
            this.$emit('update:page', 'keyEdit');
            break;
          case 'newarrayadd':
            switch(data) {
              case 'string':
                this.$set(this.mainData['keyObj'][this.mainData['arraySel']][0], this.mainData['newKey'], '');
                break;
              case 'array':
                break;
              case 'object':
                break;
            }

            if (this.mainData['newKey'].trim()) {
              //-- Save the edit
              var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=key&folderPath=ReportKeys&fileName=' + this.mainData['keySel'], { 'JSON': this.mainData['keyObj'] });

              //-- Close new key editor
              this.$set(this.mainData, 'newKeyShow', false);

              //-- Clear data
              this.$set(this.mainData, 'newKey', '');
            }
            break;

          case 'close':
            this.$emit('update:show', false);
            this.$emit('explorerClose');
            this.tableScroll();

            //-- Close new key editor
            this.$set(this.mainData, 'newKeyShow', false);
            break;
        }
      },

      //---- File Handling
      fileUploadImage: async function(file, data) {
        var imageBase64 = data.split('\,')[1];
        var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=image&folderPath=ROTimage&fileName=' + file['name'], { 'imageBase64': imageBase64 });
        // console.log(request);

        //---- Refresh Explorer
        this.loadImages();
      },
      fileUploadJSON: async function(file, data) {
        var keyObj = JSON.parse(data);
        var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=key&folderPath=ReportKeys&fileName=' + file['name'], { 'JSON': keyObj });
        // console.log(request);

        //---- Refresh Explorer
        this.loadKeys();
      },
    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
    },
  };
</script>

<style scoped>

  .explorerMain {
    width: auto;
    height: auto;
    padding: 40px;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 1000;
  }

  .explorerContent {
    width: 100%;
    height: 100%;
    padding: 10px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #ffff;
    border-radius: 4px;
    box-shadow: 0 0 8px #0004;
  }

  .explorerFunctions {
    width: 100%; 
    height: auto;
    margin: 10px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .explorerTitle {
    width: auto;
    height: 100%;
    flex: 1;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
  }

  .explorerButton {
    width: auto;
    margin: 0 0 0 4px;
  }

  /* -- Controls CSS -- */
  body button {
    width: 26px;
    height: 26px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }
  
  body button:hover {
    background-color: #eeef;
  }
  
  body button:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body button svg {
    width: auto;
    height: auto;
    position: absolute;
    top: 1px;
    bottom: 1px;
    left: 1px;
    right: 1px;
    fill: #0000;
    stroke: #000f;
    stroke-width: 12px;
    pointer-events: none;
  }

  body button.selected {
    background-color: #99ceff;
  }

  body input {
    width: 100%;
    height: 26px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body input:hover {
    border: solid 1px #0004;
  }
  
  body input:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  body select {
    width: 100%;
    height: 26px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body select:hover {
    border: solid 1px #0004;
  }
  
  body select:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  body textarea {
    width: 100%;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
    resize: none;
  }

  body textarea:hover {
    border: solid 1px #0004;
  }
  
  body textarea:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  /* -- Table CSS -- */

  .tableNone {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  .tableMain {
    width: 100%;
    height: auto;
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow: auto;
  }

  .tableRow {
    width: 100%;
    height: 34px;
    min-width: 300px;
    min-height: 34px;
    margin: 0 0 4px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ffff;
    user-select: none;
  }

  .tableFileDetails {
    width: auto;
    height: 100%;
    padding: 0 4px;
    flex: 1;
    position: relative;
  }

  .tableFileName {
    width: auto;
    height: auto;
    padding: 0 4px;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    top: 0px;
    bottom: 10px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .tableFileLastEdit {
    width: auto;
    height: auto;
    padding: 0 4px;
    font-size: 8px;
    font-weight: bold;
    position: absolute;
    top: 20px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    color: #888f;
  }

  .tableFileExtension {
    width: auto;
    height: 100%;
    min-width: 60px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .tableContent {
    background-color: #eeef;
    cursor: pointer;
  }

  .tableContent:hover {
    background-color: #dddf;
  }

  .tableContent.selected {
    background-color: #99ceff88;
  }

  .newKeyMain {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    border-radius: 4px;
  }

  .newKeyBody {
    width: 200px;
    height: 150px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border-radius: 4px;
    box-shadow: 0 0 8px #0004;
  }

  .newKeyTitle {
    width: 100%;
    height: 20px;
    padding: 0 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
  }

  .newKeyFunctions {
    width: 100%;
    height: auto;
    margin: 5px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: flex-start; 
  }

  .newKeyFunctions > button {
    width: auto;
  }

  .newKeyLowerFunctions {
    width: 100%;
    height: auto;
    flex: 1;
    margin: 5px 0 0 0;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end; 
  }

  .newKeyLowerFunctions > button {
    width: auto;
  }

</style>